import styled from 'styled-components';
import JobCreateOptions from '../../../../shared/components/jobs/app/JobCreateOptions';
import { JobPackage } from '../../../../shared/model/JobPackage';
import { Container, ContainerContentStandard } from '../../../../shared/styles/container';
import { device } from '../../../../shared/styles/device';
import Layout from '../../components/global/Layout';
import Seo from '../../components/global/Seo';
import { joboptions, priceFootnote } from '../../components/jobs/JobsPackages';
import SMELogo from '/public/svg/Logo.svg';

const HeroSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  text-align: center;
  padding-top: 32px;
  padding-bottom: 48px;  

  h1 {
    font-weight: 800;
    font-size: 32px;
    line-height: 46px;
    margin-top: 0;
    margin-bottom: 16px;

    span {
        display: block;
        color: ${(props) => props.theme.colors.fontBlack};
    }
  }

  p {
    font-size: 18px;
    line-height: 26px;
    margin-top: 0px;
    max-width: 700px;
    font-weight: 700;
    color: #86868b;
    margin-bottom: 0px;

    span {
        color: ${(props) => props.theme.colors.buttonPrimary};
    }
  }

  a {
    display: block;
    align-self: center;
  }
  
  @media ${device.tablet} {
        padding-top: 64px;
        padding-bottom: 128px;  
        h1 {
            font-size: 75px;
            line-height: 90px;
        }

        p {
            margin-top: 16px;
            margin-bottom: 0;
            font-size: 24px;
            line-height: 31px;
        }
  }
`;

const LogoWrapper = styled.div`
    svg {
        height: 80px;
        width: 80px;
    }

    @media ${device.tablet} {
        svg {
            height: 100px;
            width: 100px;
        }
    }
`;

const JobOptionsWrapper = styled.section`
    .job-options-headline {
        margin-top: 0;
        text-align: center;
    }
    margin-bottom: 64px;
`;

const JobsCompanyPage = () => {

    const onChoose = (jobPackage: JobPackage) => {
        window.open("mailto:hi@easyboarding.de?subject=Infos zur easyboarding Jobbörse");
    }

    const title = 'Job ausschreiben und die ganze Touristik erreichen';
    const description = 'Job ausschreiben und die ganze Touristik erreichen - Wir haben die Community, Sie die passenden Jobs';
    return (
        <>
            <Seo title={title} description={description} />
            <Layout preview={false}>
                <Container>
                    <ContainerContentStandard>
                        <HeroSection>
                            <LogoWrapper>
                                <SMELogo />
                            </LogoWrapper>
                            <h1>
                                <div>Job ausschreiben und die</div>
                                <div>ganze Touristik erreichen</div>
                            </h1>
                            <p>
                                Um Stellen aller Karrierestufen zu besetzen, bieten wir neben Speed-Recruiting-Event und unserem Talentpool auch <span>klassische Jobanzeigen</span> an – damit Ihre Positionen nicht unbesetzt bleiben.
                                <br /> <br />
                                <span>Nehmen Sie einfach per Mail Kontakt zu uns auf</span>, lassen Sie sich beraten und schon schalten wir Ihr Unternehmensprofil frei, mit dem Sie eigenständig Ihre Jobanzeigen buchen können.
                            </p>
                        </HeroSection>
                        <JobOptionsWrapper>
                            <h2 className='job-options-headline'>Wir haben die Community, Sie die passenden Jobs</h2>
                            <JobCreateOptions onChoose={onChoose} buttonText={"Per Mail Infos anfordern"} joboptions={joboptions} footnote={priceFootnote} />
                        </JobOptionsWrapper>
                    </ContainerContentStandard>
                </Container>
            </Layout >
        </>
    )
}

export default JobsCompanyPage;

/* export async function getServerSideProps(context) {
    const { req: { headers, url }, res } = context;
    return {
        props: {
            //agentur
        },
    };
}
 */